
(function () {
  if (window.__caelisBundleATCInstalled) return;
  window.__caelisBundleATCInstalled = true;

  const originalFetch = window.fetch;

  window.fetch = function (input, init) {
    const request = originalFetch.apply(this, arguments);

    try {
      const url = new URL(
        typeof input === 'string' ? input : input.url,
        location.href
      );

      const method = (
        init?.method || input?.method || 'GET'
      ).toUpperCase();

      const body = init?.body;

      const isKachingBundle =
        (body instanceof FormData &&
          Array.from(body.keys()).some(key =>
            key.includes('_kaching_bundles')
          )) ||
        (typeof body === 'string' &&
          body.includes('_kaching_bundles'));

      const isCartAdd =
        /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);

      if (method === 'POST' && isCartAdd && isKachingBundle) {
        request.then(response => {
          if (!response.ok) return;

          if (window.Shopify?.analytics?.publish) {
            Promise.resolve(
              window.Shopify.analytics.publish(
                'caelis:bundle_added',
                { source: 'kaching_bundles' }
              )
            )
              .then(() => {
                console.log('[Caelis] Bundle ATC published');
              })
              .catch(error => {
                console.error('[Caelis] Publish failed', error);
              });
          } else {
            console.warn('[Caelis] Shopify Analytics unavailable');
          }
        }).catch(error => {
          console.warn('[Caelis] Cart request failed', error);
        });
      }
    } catch (error) {
      console.warn('[Caelis] Tracking error', error);
    }

    return request;
  };

  console.log('[Caelis] Bundle ATC listener installed');
})();
